"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.respectOverflow = exports.portraitStyle = exports.landscapeStyle = exports.baseImageCss = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _theme = require("../theme");

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  ", ";\n  width: 100%;\n  height: auto;\n  max-height: unset;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  ", ";\n  width: auto;\n  max-width: unset;\n  height: 100%;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  transition: opacity 0.3s cubic-bezier(0.1, 0.25, 0.75, 0.9);\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  display: block;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var styles = {
  getShapeStyle: function getShapeStyle(_ref) {
    var theme = _ref.theme,
        shape = _ref.shape;
    return {
      boxSizing: 'border-box',
      display: 'inline-block',
      position: 'relative',
      backgroundColor: theme.components.image.color.background,
      borderRadius: theme.components.image.shape[shape].borderRadius
    };
  },
  getFillStyle: function getFillStyle(_ref2) {
    var imageFit = _ref2.imageFit,
        width = _ref2.width,
        height = _ref2.height,
        fitContainer = _ref2.fitContainer;

    if (fitContainer) {
      return {
        width: '100%',
        height: '100%'
      };
    }

    return {
      width: width ? width : 'auto',
      height: height ? height : 'auto'
    };
  },
  getImgStyle: function getImgStyle(_ref3) {
    var theme = _ref3.theme,
        shape = _ref3.shape;
    return {
      overflow: 'hidden',
      borderRadius: theme.components.image.shape[shape].borderRadius
    };
  }
};
var baseImageCss = (0, _theme.css)(_templateObject());
exports.baseImageCss = baseImageCss;
var landscapeStyle = (0, _theme.css)(_templateObject2(), baseImageCss);
exports.landscapeStyle = landscapeStyle;
var portraitStyle = (0, _theme.css)(_templateObject3(), baseImageCss);
exports.portraitStyle = portraitStyle;
var respectOverflow = (0, _theme.css)({
  overflow: 'hidden',
  width: '100%',
  height: '100%',
  boxSizing: 'border-box',
  position: 'relative',
  borderRadius: 'inherit'
});
exports.respectOverflow = respectOverflow;
var _default = styles;
exports.default = _default;